export default __webpack_public_path__ + "static/media/searchImg.22619344.svg";